import { render, staticRenderFns } from "./TopMenuNavList.vue?vue&type=template&id=b5341de6"
import script from "./TopMenuNavList.vue?vue&type=script&lang=js"
export * from "./TopMenuNavList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports